exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media screen and (min-width:64em){.gift_customization___wrap[data-v-fd005470] .breadcrumb{padding:0 1.875rem}}", ""]);

// exports
